export default "__VITE_ASSET__DIK_epuP__"